import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UserInfo } from '@shared/types';
import { FormLabelComponent } from '@ui-kit/form';
import { EllipsisTooltipComponent } from '@ui-kit/miscs/ellipsis-tooltip/ellipsis-tooltip.component';

@Component({
    selector: 'user-info',
    standalone: true,
    imports: [EllipsisTooltipComponent, TranslateModule, FormLabelComponent],
    templateUrl: './user-info.component.html',
    styleUrls: ['./user-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserInfoComponent {
    user = input.required<UserInfo | null>();
    isCentered = input<boolean>(false);

    label = input<string | null>(null);
}
